import { render, staticRenderFns } from "./VehicleIdentification.vue?vue&type=template&id=01aca3bb&"
import script from "./VehicleIdentification.vue?vue&type=script&lang=js&"
export * from "./VehicleIdentification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports